import qs from 'qs';

import { ENDPOINT_ROOT } from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const getProductsPredictions = ({
  queryKey: [endpoint, source, products, limit],
}) => {
  const params = {
    limit,
    source,
    products,
  };

  return axiosAuth
    .get(`${ENDPOINT_ROOT}/${endpoint}`, {
      params,
      paramsSerializer: (item) => qs.stringify(item, { encode: false }),
    })
    .then((res) => res.data);
};

export default getProductsPredictions;
